import React from "react";
import { toast } from "react-toastify";
import { useAuthCheckMutation } from "./redux/api/api";
import { AuthCheck, UserJWTCredentials } from "./types/authTypes";
import jwtDecode from "jwt-decode";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "./redux/store";
import { setCredentials } from "./redux/slices/userSlice";
import MainRoutes from "./routes/MainRoutes";
import { useNavigate } from "react-router-dom";

function App() {

 

  const [userCredentials, setUserCredentials] = React.useState<string>("");
  const [check, result] = useAuthCheckMutation();
  const user = useSelector((store: RootState) => store.user);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  React.useLayoutEffect(() => {
    //Procura pelo item no local storage e adiciona ao estado
    let token = localStorage.getItem("token");

    if (token) setUserCredentials(token);
  }, []);

  React.useEffect(() => {
    //Caso existam credenciais no estado, elas são validadas junto ao servidor
    if (userCredentials) {
      check(userCredentials);
      //Caso as credenciais sejam um token JWT, são decodificadas e enviadas ao contexto global
      try {
        let userJWTCredentials: UserJWTCredentials = jwtDecode(userCredentials);
        dispatch(setCredentials(userJWTCredentials));
      } catch (err) {
        //
        
      }
    }
  }, [userCredentials]);

  React.useEffect(() => {
    //Caso as credenciais forem inválidas, são removidas do localStorage e do estado

    if (result.isError && (result.error as AuthCheck).status == "401") {
      localStorage.removeItem("token");
      setUserCredentials("");
      navigate('/login')
      toast.info("Sua sessão expirou!");
    }else if(result.isError && (result.error as AuthCheck)?.status === "FETCH_ERROR"){
      toast.error("Erro de rede, verifique a sua conexão!")
    }
  }, [result]);

    return <MainRoutes/>
  
}

export default App;
